/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import Packages
import 'svgxuse'
import { gsap } from 'gsap'
import inlineSVG from 'inline-svg'
import SlimSelect from 'slim-select'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

// Import modules
import Video from './modules/video'
import Sticky from './modules/sticky'
import ImageBanner from './modules/ImageBanner'
import Navigation from './modules/navigation'
import Animations from './modules/animations'
import PageNav from './modules/page-nav'

const App = {
    config: {
        selects: [],
    },
    initSticky() {
        new Sticky({
            elem: '.site-header',
            stickyTop: '.page-template-careers #head-banner .cta, .elmntl-menu .header-wrapper, .page-template-about .page-sticky-top'
        })
    },
    initSecondNav() {
        new Navigation({
            elem: '#secondary-navigation',
            toggleBtn: '#secondary-button',
            navMenu: '#secondary-navigation-menu'
        })
    },
    initMobileNav() {
        new Navigation({
            elem: '#mobile-navigation',
            openBtn: '#mobile-button-open',
            closeBtn: '#mobile-button-close',
            navMenu: '#mobile-navigation-menu'
        })
    },
    initLazyLoadImageBanner() {
        new ImageBanner()
    },
    initVideoBanner() {
        new Video({
            elem: '.banner-video',
            playPause: '#play-pause',
            sound: '#sound'
        })
    },
    initInlineSVG() {
        inlineSVG.init({
            svgSelector: 'img.inline-svg'
        })
    },
    initAnimation() {
        new Animations()
    },
    initSelect() {

        const selects = document.querySelectorAll('select')

        if (selects.length > 0) {
            selects.forEach((select, index) => {
                this.config.selects[index] = new SlimSelect({
                    select: select,
                    allowDeselectOption: true
                })
            })
        }
    },
    initPageNav() {
        new PageNav()
    },
    initDisablePhone() {
        let tel = document.querySelector(".page-template-contact #contact-tel a");

        if (tel) {
            if (window.innerWidth > 768 ) {
            tel.removeAttribute("href");
            }
        }
    },
    initFormUploadBtn() {
        const uploads = document.querySelectorAll('.ginput_container_fileupload');

        if ( uploads.length < 0 ) return;

        uploads.forEach((upload) => {
            const uploadBtn = upload.parentNode.querySelector('.gfield_label');
            const uploadInput = upload.querySelector('[type="file"]')
            const preview = upload.querySelector('.ginput_preview')
            const currUploadText = uploadBtn.innerHTML

            if (preview) {
                const previewFilename = preview.querySelector('strong')
                uploadBtn.innerHTML = previewFilename.innerHTML
            } else {
                uploadBtn.innerHTML = currUploadText
            }

            uploadBtn.addEventListener('click', function () {
                upload.click();
            });
            
            uploadInput.addEventListener('change', function(e) {
                const files = e.target.files

                if (files.length > 0) {
                    uploadBtn.innerHTML = files[0].name
                }
            })
        })
        
    },
    init() {

        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

        this.initLazyLoadImageBanner()
        this.initSticky()
        this.initSecondNav()
        this.initMobileNav()
        this.initVideoBanner()
        this.initInlineSVG()
        this.initAnimation()
        this.initSelect()
        this.initPageNav()
        this.initDisablePhone()
        this.initFormUploadBtn()
    }
}

window.addEventListener('DOMContentLoaded', () => {
    App.init()
} )

/**
 * Destroy and re-initialize slim select in gravity form render
 */
jQuery(document).on('gform_post_render', function() {

    const slimSelects = App.config.selects

    if (slimSelects.length > 0) {
        slimSelects.forEach((select, index) => {
            select.destroy()
        })
    }

    App.initSelect()
    App.initFormUploadBtn()
})